import Choices from 'choices.js';
import { ancestorBySelector } from "../../helpers/element/findAncestor";

function createSelect(selectBox, index) {
  const choice = new Choices(selectBox, {
    searchEnabled: (selectBox.dataset.choiceSearch === "true") ? true : false,
    itemSelectText: '',
    shouldSort: false,
    shouldSortItems: false,
    classNames: {
      containerOuter: (index !== 0) ? 'choices choices--product' : 'choices choices--product'
    },

    callbackOnCreateTemplates: function (template) {
      return {
        choice: (classNames, data) => {
          const extras = JSON.parse(data.customProperties);
          return template(`
            <div class="${classNames.item} ${classNames.itemChoice} 
            ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" 
            data-select-text="${this.config.itemSelectText}" data-choice 
            ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} 
            data-id="${data.id}" data-value="${data.value}" 
            ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
            ${(finish_data !== null && finish_data[data.value] !== undefined && finish_data[data.value] !== '') ? `<img src="${finish_data[data.value]}" alt="" />` : ``}
              ${data.label}
            </div>
          `);
        },
      };
    },
  });

  selectBox.choice = choice;

  selectBox.addEventListener('choice', (event) => {

    // Activate Fields
    const parent = ancestorBySelector(selectBox, '.product-form__field');

    if (parent) {
      if (!event.detail.choice.placeholder) {
        parent.classList.add('is-active');
      } else {
        parent.classList.remove('is-active');
      }
    }

  }, false);
}

export function initCalculatorSelect() {
  const selectBoxes = document.querySelectorAll('.af-field-type-select select:not(.choices__input)');

  if (selectBoxes.length > 0) {
    selectBoxes.forEach((selectBox, i) => {
      createSelect(selectBox, i);
    });
  }
}